import { getDataWithQueryString, getDataWithDeduplication } from "../api/componentAPIs";

const getRoutesDataForPlanning = (scenarioID) => {
  return scenarioID
    ? getDataWithDeduplication('RoutesGrid', `scenarioId=${scenarioID}`)
    : Promise.resolve({ status: 200, data: [] });
};

const getAnchorPointData = async (scenarioID) => {
  return getDataWithDeduplication('GetAnchorPoints', `scenarioId=${scenarioID}`)
    .then((response) => {
      if (response.status === 200) {
        return { success: true, data: response.data };
      } else {
        return { success: false, data: [] };
      }
    })
    .catch(() => ({ success: false, data: [] }));
};

const getTrailersData = async (terminal) => {
  return getDataWithDeduplication(
    'GetAllTrailers',
    `terminalId=${terminal.id}`
  )
    .then((response) => {
      if (response.status === 200) {
        return sortTrailersBasedOnSize(response.data);
      } else {
        return [];
      }
    })
    .catch(() => []);
};

const getWavesData = async (scenarioID) => {
  return getDataWithDeduplication('GetWaves', `scenarioId=${scenarioID}`)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        return [];
      }
    })
    .catch(() => []);
};

const sortTrailersBasedOnSize = (trailersData) => {
  const trailersDataCopy = trailersData ? [...trailersData] : [];

  // Sort trailers based on size
  trailersDataCopy.sort((trailer1, trailer2) => trailer1.trailerLength - trailer2.trailerLength);

  return trailersDataCopy;
};

const fetchDispatchStaticData = async (terminalCode) => {
  return Promise.all([
    getDataWithQueryString('getClientData', `terminalCode=${terminalCode}`),
    getDataWithQueryString('GetAllHazmatInfo', `terminalCode=${terminalCode}`)
  ]);
};

export {
  getAnchorPointData,
  getTrailersData,
  getWavesData,
  fetchDispatchStaticData,
  getRoutesDataForPlanning
};
